export default function Key(props) {
  return (
    <svg
      width="17"
      height="31"
      viewBox="0 0 17 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6875 27.4375C10.6875 27.8125 10.5625 28.125 10.25 28.375L9 29.75C8.4375 30.25 7.625 30.25 7.0625 29.75L3.625 26.25C3.0625 25.75 3.0625 24.9375 3.625 24.375L5.3125 22.6875L3.625 20.9375C3.0625 20.4375 3.0625 19.5625 3.625 19.0625L5.3125 17.3125L5.3125 16.875C2.25 15.75 -5.60052e-07 12.8125 -4.07062e-07 9.3125C-1.91237e-07 4.375 4.5625 0.437499 9.75 1.5C12.75 2.1875 15.25 4.625 15.8125 7.6875C16.6875 11.875 14.25 15.625 10.6875 16.875L10.6875 27.4375ZM4 9.3125C4 11.5625 5.8125 13.3125 8 13.3125C10.1875 13.3125 12 11.5625 12 9.3125C12 7.125 10.1875 5.3125 8 5.3125C5.8125 5.3125 4 7.125 4 9.3125Z"
        fill="white"
      />
    </svg>
  );
}
